import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import SectionHeader from "../SectionHeader";
import "./style.scss";
import Button from "../Button";
import { useNavigate } from "react-router";

const MyNiceModal = NiceModal.create(() => {
  const modal = useModal();
  const redirectSoure = modal.args?.redirectSoure;

  const handleClose = () => {
    modal.hide();
  };

  const ecommConfig = {
      discoverglode: `${import.meta.env.VITE_DG_URL}/customer/account/`,
      vusede: `${import.meta.env.VITE_VUSE_URL}/account-landing`,
  };

  const handleLeave = (touchpoint) => {
    const url = ecommConfig[touchpoint];
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"leave-program-modal"}
    >
      <SectionHeader>
        <strong>Das Programm verlassen </strong>
      </SectionHeader>
      <h2 className="leave-program-main">
        Bist du sicher, dass du das Programm verlassen möchtest?
      </h2>
      <p className="leave-program-copy">
        Solltest du dich innerhalb der<strong> nächsten 6 Monate</strong> für
        deine Rückkehr entscheiden, kannst du sicher sein, dass deine Punkte und
        die Gutscheine wieder aktiviert werden.
      </p>
      <div className="leave-program-buttons-wrapper">
        <Button
          btnClass="yellow outline reversed"
          action={() => {
            handleClose();
          }}
        >
          Nein
        </Button>
        <Button action={() => handleLeave(redirectSoure)} btnClass="yellow">
          Ja
        </Button>
      </div>
    </Modal>
  );
});

export default MyNiceModal;
